import Service from '../../services';

export const getFeaturedProjects = async params => {
  try{
    const response = await Service.isnGet(`/api/projects/featured-projects${params}`, res => res);
    return response;
  }catch(error){
    console.error(error)
  }
};
